import settings from "./settings";
import Common from "./Common";

export default class {
    /**
     * コンストラクタ
     * @param $targetElem
     * @param tooltipBody
     */
    constructor(targetElem, tooltipBody = settings.templates.tooltip) {
        this.$block = $(targetElem);
        this.$tooltip = $(tooltipBody);
        this.isEnable = true;

        // 初期スタイルの適用
        this.$tooltip.css({
            opacity: 0,
            position: "absolute",
            border: "1px solid #666",
            boxShadow: "3px 3px 4px #999"
        });

        // トリガーを有効に
        this.setTrigger();
    }

    /**
     * トリガーの追加
     */
    setTrigger() {
        this.$block.on("focusin", (e) => {
            this.open(e);
        });

        this.$block.on("focusout", (e) => {
            this.close(e);
        });
    }

    /**
     * ツールチップclose
     */
    open(e) {
        let tooltipPosition = this.tooltipPosition;
        if (this.isEnable) {
            this.$tooltip.css(tooltipPosition);
            $("body").append(this.$tooltip);
            this.$tooltip.animate({opacity: 1}, "fast");
            this.$tooltip.animate({opacity: 1}, "fast");
        }
    }

    /**
     * ツールチップopen
     */
    close(e) {
        this.$tooltip.animate({opacity: 0}, "fast", () => {
            this.$tooltip.remove();
        });
    }

    /**
     * ツールチップのポジションを設定
     * @returns {{}}
     */
    get tooltipPosition() {
        let resultPosition = {};
        let currentObjPosition;
        let windowSize;

        // サイズ取得のため一旦要素を出現させる
        $("body").append(this.$tooltip);

        currentObjPosition = this.$block.offset();

        windowSize ={
            width: $(window).width(),
            height: $(window).height()
        };

        resultPosition.left = currentObjPosition.left;
        resultPosition.top = this.$block.offset().top - this.$tooltip.height() - 8;

        // 画面より右寄りの場合は左寄りに調整
        // todo サイズを動的取得に変更
        if (windowSize.width / 2 < resultPosition.left) {
            resultPosition.left = resultPosition.left - 280;
        }

        // 要素削除
        this.$tooltip.remove();
        return resultPosition;
    }
}
